import { render, staticRenderFns } from "./StatefulLabel.vue?vue&type=template&id=02462a5f&scoped=true"
import script from "./StatefulLabel.vue?vue&type=script&lang=ts"
export * from "./StatefulLabel.vue?vue&type=script&lang=ts"
import style0 from "./StatefulLabel.vue?vue&type=style&index=0&id=02462a5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02462a5f",
  null
  
)

export default component.exports